module.exports = __webpack_public_path__ + "static/media/andembryLogo.44e73ebd.png";